import { useLocalization } from "@fluent/react";
import { Row } from "@narmi/design_system";
import { BackButton } from "@lending/components/BackButton/BackButton";
import { OfferSelect } from "@lending/components/OfferSelect/OfferSelect";
import { PageLayout } from "@lending/components/PageLayout/PageLayout";
import { useFlowNavigation } from "@lending/navigation";
import { useSelectCardContent } from "./hooks/useSelectCardContent";
import styles from "./SelectCard.module.css";
import { getOrderedCreditCardProducts } from "./utils";

export function SelectCard() {
  const { l10n } = useLocalization();
  const { handleCardClick, creditCardProducts } = useSelectCardContent();
  const { goBack } = useFlowNavigation();
  const orderedCreditCardProducts = getOrderedCreditCardProducts(creditCardProducts);

  return (
    <PageLayout style={{ minHeight: "100vh" }}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div>
            <h1>
              {l10n.getString(
                "credit-card-selection-heading",
                null,
                "Explore our credit card offers"
              )}
            </h1>
            <div className="margin--top--xs">
              {l10n.getString(
                "credit-card-selection-subheading",
                null,
                "Select the one that best fits your needs to get started."
              )}
            </div>
          </div>
          <div className={styles.cards}>
            {orderedCreditCardProducts.map((card) => (
              <OfferSelect
                key={card.id}
                chipLabel={
                  card.is_popular
                    ? l10n.getString("credit-card-selection-popular-chip", null, "Most popular")
                    : undefined
                }
                emphasize={card.is_popular}
                kind="credit_card"
                cardName={card.name}
                cardNetwork={card.card_network}
                bulletPoints={card.details}
                infoLinkText={card.more_details_copy}
                infoLinkUrl={card.more_details_link}
                isFullWidthCta
                onSelect={() => handleCardClick(card.id)}
              />
            ))}
          </div>
          <div>
            <Row alignItems="center" justifyContent="space-between">
              <BackButton onClick={goBack} />
            </Row>
          </div>
        </div>
      </div>
    </PageLayout>
  );
}
